export default function Map() {
    return (
        <div className='Map'>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3095.1902824467147!2d-111.82098942360147!3d39.124901233247606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874b81a3066f1fc3%3A0x4f264e56a2f6efe2!2s35%20E%20100%20N%20St%2C%20Centerfield%2C%20UT%2084622!5e0!3m2!1sen!2sus!4v1728143710111!5m2!1sen!2sus" width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
    );
}